// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3wHiW","info":"Note_info__1_R3p","note":"Note_note__1-WTX","actions":"Note_actions__16fhv"};